const apiBase = process.env.REACT_APP_API_URL;

export async function getPedidoByIdRoyal(pedido_id) {
  const response = await fetch(`${apiBase}/api/getPedidoByIdRoyal`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ pedido_id }),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Erro ao buscar pedido');
  }

  return data;
}

export async function getPedidosByUsuarioIdRoyal(usuario_id) {
  const response = await fetch(`${apiBase}/api/getPedidosByUsuarioIdRoyal`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ usuario_id }),
  });

  const data = await response.json();
  console.log('Resposta da API getPedidosByUsuarioIdRoyal:', data);

  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Erro ao buscar pedidos');
  }

  return data;
}

export async function startProductionRoyal(pedido_id) {
  const response = await fetch(`${apiBase}/api/startProductionRoyal`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ pedido_id }),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Erro ao iniciar produção');
  }

  return data;
}

export async function finishProductionRoyal(pedido_id) {
  const response = await fetch(`${apiBase}/api/finishProductionRoyal`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ pedido_id }),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Erro ao concluir produção');
  }

  return data;
}

export async function startSeparationRoyal(pedido_id) {
  const response = await fetch(`${apiBase}/api/startSeparationRoyal`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ pedido_id }),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Erro ao iniciar separação');
  }

  return data;
}

export async function finishSeparationRoyal(pedido_id) {
  const response = await fetch(`${apiBase}/api/finishSeparationRoyal`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ pedido_id }),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Erro ao concluir separação');
  }

  return data;
}

export async function shipOrderRoyal(pedido_id) {
  const response = await fetch(`${apiBase}/api/shipOrderRoyal`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ pedido_id }),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Erro ao enviar pedido');
  }

  return data;
}

export async function deliverOrderRoyal(pedido_id) {
  const response = await fetch(`${apiBase}/api/deliverOrderRoyal`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ pedido_id }),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Erro ao concluir entrega');
  }

  return data;
}

export async function cancelOrderRoyal(pedido_id) {
  const response = await fetch(`${apiBase}/api/cancelOrderRoyal`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ pedido_id }),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Erro ao cancelar pedido');
  }

  return data;
}